export interface OnboardingStepData {
  title: string;
  description: string;
  visual?: 'profile' | 'chat' | 'jobtracking' | null;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

export interface OnboardingStepProps {
  step: number;
  totalSteps: number;
  title: string;
  description: string;
  visual?: 'profile' | 'chat' | 'jobtracking' | null;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
  onNext: () => void;
  onSkip: () => void;
  onPrevious?: () => void;
}

export interface GuidingArrowProps {
  target: 'profile-menu' | 'chat-menu' | 'jobtracking-menu';
  direction?: 'left' | 'right' | 'up' | 'down';
  curved?: boolean;
}

export interface ArrowPosition {
  x: number;
  y: number;
  targetX: number;
  targetY: number;
}

export const ONBOARDING_COMPLETED_KEY = 'onboarding_completed_v1';
